import { useEffect } from 'react'
import { fetchExperiencesById } from 'actions/ExperienceActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import submitLoyaltyPointsBurnCalculationRequest from 'actions/loyalty/submitLoyaltyPointsBurnCalculationRequest'
import useSearchBurnEnabled from 'hooks/useSearchBurnEnabled'
import useExperiencesSearchFilters from 'components/Experiences/hooks/useExperiencesSearchFilters'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'

const PREFETCH_LIMIT = 24

/**
 * Warms experience offers and burn batch cache when burn filters are active,
 * so tile pricing is available before every tile mounts.
 */
function usePrefetchExperienceSearchBurnCalculations(
  experienceIds: Array<string> | undefined,
) {
  const dispatch = useAppDispatch()
  const { hasSelectedBurnToggle } = useSearchBurnEnabled()
  const { searchFilters } = useExperiencesSearchFilters()
  const viewPriceInPoints = !!searchFilters.viewPriceInPoints
  const isLuxPlusEnabled = useAppSelector(getIsEnabledLuxPlusDiscountedExperiences)
  const experiencesById = useAppSelector(state => state.experience.experiences)

  const shouldPrefetch = hasSelectedBurnToggle || viewPriceInPoints

  useEffect(() => {
    if (!shouldPrefetch || !experienceIds?.length) return

    const ids = experienceIds.slice(0, PREFETCH_LIMIT)
    dispatch(fetchExperiencesById(...ids))

    for (const id of ids) {
      const experience = experiencesById[id]
      if (!experience?.price) continue

      dispatch(submitLoyaltyPointsBurnCalculationRequest({
        price: experience.price,
        loyaltyProductType: 'experience',
      }))

      if (isLuxPlusEnabled && experience.pricing.memberPrice) {
        dispatch(submitLoyaltyPointsBurnCalculationRequest({
          price: experience.pricing.memberPrice,
          loyaltyProductType: 'experience',
        }))
      }
    }
  }, [
    dispatch,
    experienceIds,
    experiencesById,
    shouldPrefetch,
    isLuxPlusEnabled,
  ])
}

export default usePrefetchExperienceSearchBurnCalculations
